import { Skeleton } from "~/components/ui/skeleton";
import { cn } from "~/lib/utils";

interface ColumnConfig {
  width: string;
  height?: string;
  rounded?: boolean;
}

interface ListLoadingSkeletonProps {
  count?: number;
  showAvatar?: boolean;
  columns: ColumnConfig[];
  "aria-label"?: string;
}

export const ListLoadingSkeleton = ({
  count = 6,
  showAvatar = false,
  columns,
  "aria-label": ariaLabel = "Loading",
}: ListLoadingSkeletonProps) => {
  return (
    <div role="status" aria-label={ariaLabel} className="flex flex-col gap-2">
      {Array.from({ length: count }).map((_, i) => (
        <div
          key={i}
          className="flex items-center gap-4 rounded-lg border border-border bg-card px-4 py-3"
        >
          {showAvatar && <Skeleton className="size-9 shrink-0 rounded-full" />}
          <div className="flex flex-1 flex-col gap-1.5">
            <Skeleton className="h-3.5 w-1/3" />
            <Skeleton className="h-3 w-2/3" />
          </div>
          {columns.map((col, j) => (
            <Skeleton
              key={j}
              className={cn(
                col.width,
                col.height ?? "h-3",
                col.rounded && "rounded-full",
                "shrink-0"
              )}
            />
          ))}
        </div>
      ))}
    </div>
  );
};
